import axios from "axios";
import { Message, Loading } from "element-ui";
import router from "@/router";
import { Toast } from "vant";
const ConfigBaseURL = "http://test-api.mrbox.ai/"; //默认路径，这里也可以使用env来判断环境
//使用create方法创建axios实例
export const Service = axios.create({
  timeout: 7000, // 请求超时时间
  baseURL: ConfigBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 添加请求拦截器
Service.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("u_dc_token") || "";

    config.headers.authorization = token;
    return config;
  },
  (error) => {
    if (error.response.status === 404) {
      router.push("/network-error"); // 跳转到网络错误页面
    }
    return Promise.reject(error);
  }
);
// 添加响应拦截器
Service.interceptors.response.use(
  (response) => {
    if (response.data.msg == "未获取到token" || response.data.msg == "无权限") {
      router.push({
        path: "/login",
      });
    } else if (response.data.code == 300) {
      Toast(response.data.msg);
    }
    return response.data;
  },
  (error) => {
    console.log("响应拦截", error);
    if (error.code === "ECONNABORTED") {
      // 处理超时错误
      console.log("当前路由", router.currentRoute);
      const currentRoute = router.currentRoute; // 获取当前路由信息
      if (currentRoute.path != "/network-error") {
        let time = setTimeout(() => {
          router.push("/network-error"); // 跳转到网络错误页面
          clearTimeout(time);
        });
      }
    } else {
      const msg = error.Message !== undefined ? error.Message : "";
      Message({
        message: "网络错误" + msg,
        type: "error",
        duration: 3 * 1000,
      });
    }
    return Promise.reject(error);
  }
);
